import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};
  padding: ${spacing[24]} ${spacing[16]};
  border-radius: 8px;
  background: linear-gradient(
      72deg,
      rgba(255, 255, 255, 0) 34.7%,
      rgba(255, 255, 255, 0.2) 99.71%
    ),
    #1269ec;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};
`;

export const Heading = styled.p`
  ${font('display', 'xs', '500')}
  color: ${color.common.white};
`;

export const Subhead = styled.div`
  &,
  & p {
    ${font('text', 'md', '500')}
    color: ${color.common.white};
  }
`;
